import { Locale } from '@core/Entities/Locale/Locale.entity';

import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';
import { VehicleFinance } from '@core/Entities/Vehicle/VehicleFinance.entity';
import { VehiclePricing } from '@core/Entities/Vehicle/VehiclePricing.entity';

export function getFormattedFinanceValuesFromVehicle(
  vehicleFinance: VehicleFinance,
  vehiclePricing: VehiclePricing,
  locale: Locale,
) {
  const monthlyPrice = Math.ceil(vehicleFinance.rate);
  const formattedDeposit = getFormattedCurrency(vehicleFinance.deposit, locale);
  const formattedTotalPrice = getFormattedCurrency(vehiclePricing.price, locale);
  const formattedMonthlyPrice = getFormattedCurrency(monthlyPrice, locale);
  const formattedFinalRate = getFormattedCurrency(vehicleFinance.finalRate, locale);

  return {
    deposit: formattedDeposit,
    totalPrice: formattedTotalPrice,
    monthlyPrice: formattedMonthlyPrice,
    finalRate: formattedFinalRate,
    months: vehicleFinance.months || 0,
    mileage: vehicleFinance.mileage || 0,
  };
}
